import { useLocation } from "react-router-dom";

const VerifyEmail = () => {
  const location = useLocation();
  const email = location.state?.email || "your email";

  return (
    <div className="flex min-h-[calc(100vh-4rem)] w-full flex-col overflow-y-auto bg-blue-50 p-6 dark:bg-slate-900">
      <div className="flex flex-col items-center justify-center flex-grow w-full h-full max-h-screen">
        <div className="p-10 bg-white dark:bg-slate-800 rounded-2xl shadow-lg flex flex-col items-center gap-6 w-full max-w-md">
          <div className="text-center text-zinc-800 dark:text-zinc-200 text-3xl font-medium">
            Email Verification
          </div>
          <div className="text-stone-500 dark:text-stone-400 text-opacity-80 text-lg text-center">
            Please check your email (
            <span className="font-semibold">{email}</span>) for a verification
            link.
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
